console.log('animation.js LOADED (before listener)');

window.addEventListener('splash:finished', () => {
  console.log('[mainv] splash:finished received');
  startMainvTextAnim();
}, { once: true });

console.log('animation.js listener registered');



  function delayScrollAnime() {
    var timeStep = 0.2; // 1要素ごとの追加ディレイ秒
    $(".js-scroll").each(function () {
      var parent = this;
      // すでに一度発火したらスキップ
      if ($(parent).hasClass("is-animated")) return;

      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();

      // トリガー閾値（統一: 15%）
      var triggerOffset = windowHeight * 0.15;

      if (scroll >= elemPos - windowHeight + triggerOffset) {
        var value = timeStep;
        var childs = $(this).children();
        $(this).css("opacity", 1); // 親は見える状態へ
        $(childs).each(function () {
          $(this).css("animation-delay", value + "s");
          $(this).addClass("fadeUp");
          value += timeStep;
        });
        $(parent).addClass("is-animated"); // 一度だけ
      }
    });
  }

  // スクロール・ロード時（間引き）
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        delayScrollAnime();
        ticking = false;
      });
    }
  }
  $(window).on("scroll", onScroll);
  $(window).on("load", function () {
    delayScrollAnime();
  });

  // ========== 2) シンプルなフェード（show-fade） ==========
  function simpleFade() {
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    var triggerOffset = windowHeight * 0.15; // 統一: 15%

    $(".fade").each(function () {
      var imgPos = $(this).offset().top;
      if (scroll > imgPos - windowHeight + triggerOffset) {
        $(this).addClass("show-fade");
        // 繰り返し不要なら属性やフラグを付けて二度目以降の処理を避けてもOK
      }
    });
  }
  $(window).on("scroll", function () {
    requestAnimationFrame(simpleFade);
  });
  $(window).on("load", simpleFade);

  // ========== 3) 画像イン（show-img）SP/PC閾値切り替え ==========
  function imgIn() {
    var winW = $(window).width();
    var showH = winW <= 767 ? 100 : 300; // SP/PCで閾値を変更
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();

    $(".img-in img").each(function () {
      var imgPos = $(this).offset().top;
      if (scroll > imgPos - windowHeight + showH) {
        $(this).addClass("show-img");
      } else {
        // 一度だけなら外さない
        // $(this).removeClass("show-img");
      }
    });
  }
  $(window).on("scroll", function () {
    requestAnimationFrame(imgIn);
  });
  $(window).on("load resize", imgIn);

  // ========== 4) inViewトリガー（個別解除で統一） ==========
 if (typeof window.inView === 'function') {
  window.inView.offset(0.15 * window.innerHeight);

  window.inView('[data-inview]')
    .on('enter', el => {
      el.classList.add('is-inview');
      el.removeAttribute('data-inview');
    })
    .on('exit', el => {
      // 必要なら
    });

  window.addEventListener('resize', () => {
    window.inView.offset(0.15 * window.innerHeight);
  });
}

// data-delay属性で遅延指定（ms）※これは inView と無関係なので残す
document.querySelectorAll('.fade-in[data-delay]').forEach(el => {
  const d = parseInt(el.getAttribute('data-delay'), 10);
  if (!Number.isNaN(d)) el.style.transitionDelay = d + 'ms';
});


  //TOP GSAP
 function startMainvTextAnim() {
  if (window.__mainvTextAnimStarted) return;
  window.__mainvTextAnimStarted = true;

  if (!window.gsap) return;

  const txtWrap = document.querySelector('.p-mainv__txt');
  const bnr = document.querySelector('.p-mainv__bnr');
  if (!txtWrap) return;

  const h1 = txtWrap.querySelector('h1');
  const ps = Array.from(txtWrap.querySelectorAll('p')); // ← ここが重要（p.markerは使わない）
  if (!h1) return;

  // 初期状態（非表示）をGSAPで作る
  gsap.set(txtWrap, { autoAlpha: 1 }); // visibility/opacityをまとめて扱う
  gsap.set(ps, { y: 14, autoAlpha: 0 });
  if (bnr) gsap.set(bnr, { y: 16, autoAlpha: 0 });

  let chars = null;

  // SplitTypeがあるならh1を文字単位で。なければh1全体でフェードアップ
  if (window.SplitType) {
    const split = new SplitType(h1, { types: 'chars' });
    chars = split.chars;
    gsap.set(chars, { yPercent: 120, opacity: 0, rotateX: -70, transformPerspective: 600 });
  } else {
    gsap.set(h1, { y: 18, autoAlpha: 0 });
  }

  const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

  if (chars) {
    tl.to(chars, {
      yPercent: 0,
      opacity: 1,
      rotateX: 0,
      duration: 0.9,
      stagger: 0.03
    });
  } else {
    tl.to(h1, { y: 0, autoAlpha: 1, duration: 0.6 });
  }

  // pを順番に表示
  if (ps.length) {
    tl.to(ps, { y: 0, autoAlpha: 1, duration: 0.5, stagger: 0.12 }, '-=0.2');
  }

  // 最後にバナー（ボタン群）
  if (bnr) {
    tl.to(bnr, { y: 0, autoAlpha: 1, duration: 0.6 }, '-=0.1');
  }
}

window.addEventListener('splash:finished', startMainvTextAnim, { once: true });

if (document.documentElement.classList.contains('is-splash-finished')) {
  startMainvTextAnim();
}

function startSubheadAnim() {
  if (window.__subheadAnimStarted) return;
  window.__subheadAnimStarted = true;

  if (!window.gsap) return;

  const wrap = document.querySelector('.js-subhead');
  if (!wrap) return;

  const img = wrap.querySelector('.subhead__img');
  const ttl = wrap.querySelector('.subhead__ttl');

  // CSSで隠してある前提：ここからGSAPが表示責務を持つ
  if (img) gsap.set(img, { autoAlpha: 1, scale: 1.12, filter: 'brightness(0.9)' });
  if (ttl) gsap.set(ttl, { autoAlpha: 1 }); // visibilityを戻す（SplitType対策）

  let chars = null;
  if (ttl && window.SplitType) {
    const split = new SplitType(ttl, { types: 'chars' });
    chars = split.chars;
    gsap.set(chars, { yPercent: 110, opacity: 0, rotateX: -70, transformPerspective: 600 });
  } else if (ttl) {
    gsap.set(ttl, { y: 18, autoAlpha: 0 });
  }

  const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

  if (img) tl.to(img, { scale: 1, filter: 'brightness(1)', duration: 1.2 }, 0);

  if (chars) {
    tl.to(chars, { yPercent: 0, opacity: 1, rotateX: 0, duration: 0.9, stagger: 0.02 }, 0.15);
  } else if (ttl) {
    tl.to(ttl, { y: 0, autoAlpha: 1, duration: 0.7 }, 0.15);
  }
}

function startSubheadAnimWhenTop(threshold = 20) {
  if ((window.scrollY || 0) <= threshold) {
    startSubheadAnim();
    return;
  }
  const onScroll = () => {
    if ((window.scrollY || 0) <= threshold) {
      window.removeEventListener('scroll', onScroll);
      startSubheadAnim();
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
}

window.addEventListener('splash:finished', () => startSubheadAnimWhenTop(20), { once: true });

if (document.documentElement.classList.contains('is-splash-finished')) {
  startSubheadAnimWhenTop(20);
} else {
  window.addEventListener('load', () => startSubheadAnimWhenTop(20), { once: true });
}

// bfcache対策（戻る/進むで復元された時）
window.addEventListener('pageshow', (e) => {
  if (e.persisted) startSubheadAnimWhenTop(20);
});